/*
 *###############################################################################
 *Module Name                   : PromotionMaster.js                            #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               : Dinisuru Balasuriya                           #
 *Date                          : Monday , March 7th 2022, 10:10:07 am          #
 *Copyright © 2021 myPOS Software Solution (Pvt) Ltd.                           #
 *###############################################################################
 */


import React, { useEffect, useRef, useState } from "react"
import {
    Button,
    Col,
    Row
} from "reactstrap"

//**Importing required componant files   */
import DPSwitch from "framework/components/DPSwitch"
import ReactPaginate from 'react-paginate';
import DPTextBox from "framework/components/DPTextBox";
//**End Importing required componant files */
import * as XLSX from 'xlsx';


const PromotionLocationContent = ({
    loc,
    disabled,
    showAllFields,
    setLoc,
    triggerClear
}) => {

    const [searchByName, setSearchByName] = useState(true)
    const [searchTerm, setSearchTerm] = useState("")
    const [headerSwitch, setHeaderSwitch] = useState(false)

    const inputRef = useRef(null)

    useEffect(() => {
        setSearchTerm("")
        setHeaderSwitch(false)
    }, [triggerClear])

    function handleSwitchChanges(e, values, index) {
        const change = values;
        if (e) {
            change.state = true
        } else {
            change.state = false
        }
        var newStoles = [];

        for (var i = 0; i < loc.length; i++) {
            if (loc[i].code == change.code) {
                newStoles.push(change);
            } else {
                newStoles.push(loc[i]);
            }
        }
        setLoc(newStoles);
    }

    function handleHeaderSwitchChanges(e) {
        setHeaderSwitch(e)
        var newStoles = [];

        loc.map((values, index) => {
            values.state = e
            newStoles.push(values);
        })
        setLoc(newStoles);
    }


    const newDataTable = loc.filter((value) => {
        if (searchByName) {
            return value.name.toLowerCase().includes(searchTerm.toLowerCase())
        } else {
            return value.code.toLowerCase().includes(searchTerm.toLowerCase())
        }
    })


    // Function to handle file upload
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet);

            // Extract LocationCodes from the uploaded file
            const uploadedCodes = jsonData.map(item => item.LocationCode);

            // Update loc state based on matching codes
            const updatedLoc = loc.map(item => ({
                ...item,
                state: uploadedCodes.includes(item.code) // Set state to true if code matches
            }));

            setLoc(updatedLoc);

            if (inputRef.current) {
                inputRef.current.value = null;
            }

        };
        reader.readAsArrayBuffer(file);
    };



    // Function to handle file download
    const handleFileDownload = () => {

        // Create a new array with only the codes
        const codesOnly = loc.map(item => ({
            LocationCode: item.code // Adjust the property name as needed
        }));

        const ws = XLSX.utils.json_to_sheet(codesOnly);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Promotions");

        // Save the Excel file
        XLSX.writeFile(wb, "promotions.xlsx");
    };

    return (
        <React.Fragment>

            {showAllFields ? <Row style={{ marginBottom: "15px" }} >
                <Col sm={12} md={3}>
                    <DPTextBox
                        labelText={"Search"}
                        placeholder={searchByName ? "Search by Name" : "Search by Code"}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        disabled={disabled}
                    />
                </Col>
                <Col sm={12} md={2} style={{textAlign:"end"}}>
                    <Button
                        color="success"
                        onClick={() => inputRef.current.click()} // Trigger file input click
                        disabled={disabled}
                        size="sm"
                    >
                        Upload Excel
                    </Button>
                    <input
                        type="file"
                        ref={inputRef}
                        accept=".xlsx, .xls"
                        onChange={handleFileUpload}
                        disabled={disabled}
                        style={{ display: 'none' }} // Hide the default file input
                    />
                </Col>
                <Col sm={12} md={2}>
                    <Button color="primary" onClick={handleFileDownload} disabled={disabled} size="sm">
                        Download Excel
                    </Button>
                </Col>
            </Row> : null}
            {showAllFields ? <Row>
                <Col sm={12} md={6}>
                    <TableWithPagination
                        DataTables={newDataTable}
                        Disable={disabled}
                        Clear={triggerClear}
                        handleSwitchChanges={handleSwitchChanges}
                        headerSwitch={headerSwitch}
                        handleHeaderSwitchChanges={handleHeaderSwitchChanges}
                    />
                </Col>
            </Row> : null}
        </React.Fragment>
    )
}
export default PromotionLocationContent



const TableWithPagination = ({ DataTables, handleSwitchChanges, Clear, Disable, headerSwitch, handleHeaderSwitchChanges }) => { //pagination 


    useEffect(() => {
        setCurrentPage(1)
    }, [Clear])


    const [currentPage, setCurrentPage] = useState(1)
    const [postsPerPage] = useState(10)

    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = DataTables.slice(indexOfFirstPost, indexOfLastPost) //current posts list 

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    return (
        <React.Fragment>
            <Row >
                <Col sm={12} md={12} className="mb-4-sm">
                    <table className="custom-table table-bordered table-sm rounded">
                        <thead className="table-light">
                            <tr>
                                <th scope="col" style={{ width: '60px' }}>No</th>
                                <th scope="col">Code</th>
                                <th scope="col">Name</th>
                                <th scope="col" style={{ width: '60px' }}>
                                    <DPSwitch
                                        checked={currentPosts.every((values) => values.state === true)}
                                        disabled={Disable}
                                        onChange={(e) => {
                                            handleHeaderSwitchChanges(e)
                                        }}
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentPosts.map((values, index) => {
                                return (
                                    <tr key={index} className="no-hover no-pointer">
                                        <td>{indexOfFirstPost + index + 1}</td>
                                        <td>{values.code}</td>
                                        <td>{values.name}</td>
                                        <td>
                                            <DPSwitch
                                                checked={values.state}
                                                disabled={Disable}
                                                onChange={(e) => {
                                                    handleSwitchChanges(e, values, values.id)
                                                }}
                                                rowClass={"mb-0"}
                                            // divClass={"col-md-12 mb-0"}
                                            />
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </Col>
            </Row>

            <Row>
                <Col sm={12} md={12} className="mb-4-sm mt-2">
                    <ReactPaginate
                        previousLabel={'previous'}
                        nextLabel={'next'}
                        breakLabel={'...'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={Math.ceil(DataTables.length / postsPerPage)}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        forcePage={currentPage - 1}
                        renderOnZeroPageCount={null}
                        activeClassName={'active'}
                        activeLinkClassName={'page-link'}
                        containerClassName={'pagination justify-content-end pagination-sm'}

                    />
                </Col>
            </Row>

        </React.Fragment>
    )
}
